<template>
  <div class="animated fadeIn accelerator-requests" v-if="pageLoaded">
    <Loading />
    <b-card style="border: 0" class="mt-0 mb-0 common-card">
      <h3>کد مقاله: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت مقاله: {{ proposal.status }}</h4>
      <hr />
      <v-btn
        style="float: left"
        v-if="tabIndex == 0"
        class="bc-purple"
        @click="saveDocx('doc')"
        elevation="0"
      >
        <v-icon small class="fa fa-file-word-o pe-2 white--text"></v-icon>
        <span class="white--text text-capitalize"> دریافت Word </span>
      </v-btn>
      <!-- docx -->
      <div v-show="false" id="doc">
        <div class="all" style="text-align: right">
          <h1
            style="
              display: inline-block;
              text-align: center;
              padding: 5px 0;
              border-bottom: 3px solid black;
            "
          >
            کد مقاله:
            <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
              proposal.requestsCode
            }}</span>
          </h1>
          <div>
            <h2 style="color: black; direction: rtl">
              تاریخ خروجی: {{ exportDate }}
            </h2>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات مقاله
            </h2>
            <div>
              <ul>
                <li :class="proposal.faSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان فارسی: </strong>{{ proposal.faSubject }}
                </li>
                <li :class="proposal.enSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان انگلیسی: </strong
                  >{{ proposal.enSubject }}
                </li>
                <li :class="proposal.universityId ? 'done' : 'required'">
                  <strong>دانشگاه محل اجرای مقاله: </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.universityId == notUniversity"
                  :class="proposal.otherUniversity ? 'done' : 'required'"
                >
                  <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
                </li>
                <li
                  v-if="proposal.mehvarId != notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور مقاله: </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور مقاله: </strong> سایر محورها
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.otherMehvars ? 'done' : 'required'"
                >
                  <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong>ماهیت مقاله: </strong>
                  <ul>
                    <li v-if="proposal.typeStudy">مطالعاتی</li>
                    <li v-if="proposal.typeSystemicDevelopmental">
                      سیستمی و توسعه‌ای
                    </li>
                    <li v-if="proposal.typePractical">کاربردی</li>
                  </ul>
                </li>
                <li>
                  <strong>حوزه مقاله: </strong>
                  <ul>
                    <li v-if="proposal.zoneMedicine">پزشکی</li>
                    <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                    <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                    <li v-if="proposal.zoneIndustrial">صنعتی</li>
                    <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                    <li v-if="proposal.zoneOther">سایر</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات نویسنده
            </h2>

            <b-table
              responsive
              small
              show-empty
              bordered
              head-variant="light"
              :items="proposal.colleagues"
              :fields="writersField"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>

            <strong> آیا نویسنده‌ی مسئول مقاله هستید؟ </strong
            >{{ proposal.responsibleAuthor ? "بله" : "خیر" }} <br />
            <span v-if="!proposal.responsibleAuthor"
              ><strong>رضایت نامه نویسنده مسئول موجود می باشد؟ </strong
              >{{ proposal.consentResponsibleAuthorFile ? "بله" : "خیر" }}</span
            >
            <ul>
              <li :class="proposal.executorIBAN ? 'done' : 'required'">
                <strong>شماره شبا: </strong>{{ proposal.executorIBAN }}
              </li>
              <li :class="proposal.executorBankName ? 'done' : 'required'">
                <strong>نام بانک: </strong>{{ proposal.executorBankName }}
              </li>
              <li
                :class="proposal.executorBankAccountName ? 'done' : 'required'"
              >
                <strong>نام صاحب حساب: </strong
                >{{ proposal.executorBankAccountName }}
              </li>
              <li :class="proposal.executorTel ? 'done' : 'required'">
                <strong>شماره تماس: </strong>{{ proposal.executorTel }}
              </li>
            </ul>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              مشخصات
            </h2>
            <div>
              <ul>
                <li :class="proposal.enSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان انگلیسی: </strong
                  >{{ proposal.enSubject }}
                </li>
                <li :class="proposal.abstract ? 'done' : 'required'">
                  <strong>چکیده: </strong><br />{{ proposal.abstract }}
                </li>
                <li :class="proposal.keywords ? 'done' : 'required'">
                  <strong>کلید واژگان: </strong><br />{{ proposal.keywords }}
                </li>
                <li :class="proposal.doi ? 'done' : 'required'">
                  <strong>شناسه دیجیتال مجله: </strong
                  ><span
                    style="direction: ltr; font-family: Bahnschrift SemiBold"
                    >{{ proposal.doi }}</span
                  >
                </li>
                <li :class="proposal.ISSN ? 'done' : 'required'">
                  <strong>ISSN مجله: </strong>
                  <div v-if="proposal.ISSN">
                    <span
                      v-for="(item, index) in proposal.ISSN"
                      :key="index"
                      class="badge"
                      style="font-size: 15px"
                    >
                      {{ item }}
                      <span v-if="index != proposal.ISSN.length - 1">,</span>
                    </span>
                  </div>
                </li>

                <li :class="proposal.impactFactor ? 'done' : 'required'">
                  <strong>ضریب تاثیر مجله: </strong>{{ proposal.impactFactor }}
                </li>
                <li :class="proposal.acknowledgment ? 'done' : 'required'">
                  <strong>تشکرات: </strong><br />{{ proposal.acknowledgment }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              زمان‌بندی
            </h2>
            <ul>
              <li
                :class="proposal.articlePublicationDate ? 'done' : 'required'"
              >
                <strong>تاریخ چاپ (شمسی): </strong
                ><span style="direction: ltr; font-family: B Nazanin">{{
                  proposal.articlePublicationDate
                }}</span>
              </li>
              <li
                :class="proposal.articlePublicationDate ? 'done' : 'required'"
              >
                <strong>تاریخ چاپ (میلادی): </strong>
                <span>{{
                  proposal.articlePublicationDate
                    ? moment(
                        proposal.articlePublicationDate,
                        "jYYYY/jMM/jDD"
                      ).format("DD/MM/YYYY")
                    : "-"
                }}</span>
              </li>
              <li :class="proposal.articleSubmissionDate ? 'done' : 'required'">
                <strong>تاریخ ثبت (شمسی): </strong
                ><span style="direction: ltr">{{
                  proposal.articleSubmissionDate
                }}</span>
              </li>
              <li :class="proposal.articleSubmissionDate ? 'done' : 'required'">
                <strong>تاریخ ثبت (میلادی): </strong>
                {{
                  proposal.articleSubmissionDate
                    ? moment(
                        proposal.articleSubmissionDate,
                        "jYYYY/jMM/jDD"
                      ).format("DD/MM/YYYY")
                    : "-"
                }}
              </li>
              <li :class="proposal.articleRevisionDate ? 'done' : 'required'">
                <strong>تاریخ بازبینی (شمسی): </strong
                ><span style="direction: ltr">{{
                  proposal.articleRevisionDate
                }}</span>
              </li>
              <li :class="proposal.articleRevisionDate ? 'done' : 'required'">
                <strong>تاریخ بازبینی (میلادی): </strong
                >{{
                  proposal.articleRevisionDate
                    ? moment(
                        proposal.articleRevisionDate,
                        "jYYYY/jMM/jDD"
                      ).format("DD/MM/YYYY")
                    : "-"
                }}
              </li>
              <li :class="proposal.articleAcceptanceDate ? 'done' : 'required'">
                <strong>تاریخ پذیرش (شمسی): </strong
                ><span style="direction: ltr">{{
                  proposal.articleAcceptanceDate
                }}</span>
              </li>
              <li :class="proposal.articleAcceptanceDate ? 'done' : 'required'">
                <strong>تاریخ پذیرش (میلادی): </strong
                >{{
                  proposal.articleAcceptanceDate
                    ? moment(
                        proposal.articleAcceptanceDate,
                        "jYYYY/jMM/jDD"
                      ).format("DD/MM/YYYY")
                    : "-"
                }}
              </li>
              <li :class="proposal.articleReleaseDate ? 'done' : 'required'">
                <strong>تاریخ انتشار (شمسی): </strong
                ><span style="direction: ltr">{{
                  proposal.articleReleaseDate
                }}</span>
              </li>
              <li :class="proposal.articleReleaseDate ? 'done' : 'required'">
                <strong>تاریخ انتشار (میلادی): </strong
                >{{
                  proposal.articleReleaseDate
                    ? moment(
                        proposal.articleReleaseDate,
                        "jYYYY/jMM/jDD"
                      ).format("DD/MM/YYYY")
                    : "-"
                }}
              </li>
            </ul>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              میزان وجه تشویقی
            </h2>
            <div>
              <strong>مبلغ: </strong>
              <span
                style="font-size: 16px"
                v-if="0 < proposal.impactFactor && proposal.impactFactor < 4"
              >
                2,000,000 تومان
              </span>
              <span
                style="font-size: 16px"
                v-else-if="
                  4 <= proposal.impactFactor && proposal.impactFactor <= 8
                "
              >
                3,000,000 تومان
              </span>
              <span
                style="font-size: 16px"
                v-else-if="proposal.impactFactor > 8"
              >
                4,000,000 تومان
              </span>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              تعهدات
            </h2>
            <div>
              <ul>
                <li v-if="proposal.promiseArrays[0]">
                  این مقاله در بخش حمایت از رساله های دکتری و یا در بخش حمایت از
                  پایان نامه های ارشد زیست فناوری مورد حمایت قرار نگرفته است.
                </li>
                <li v-if="proposal.promiseArrays[1]">
                  ملاک IF بر اساس JCR سال 2018 مورد تایید خواهد بود.
                </li>
                <li v-if="proposal.promiseArrays[2]">
                  ملاک میزان حمایت میزان دقیق IF خواهد بود.
                </li>
                <li v-if="proposal.promiseArrays[3]">
                  ثبت در خواست هیچگونه حقی برای پذیرش مقاله ایجاد نمی کند.
                </li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <!-- docx -->
      <b-tabs pills v-model="tabIndex" class="mt-8">
        <b-tab title="چکیده طرح" lazy>
          <Article
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :companies="companies"
            :isLoaded="isLoaded"
          />
        </b-tab>
        <b-tab title="داوری" active>
          <Review />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Article from "./../../components/AcceleratorArticle";
import Review from "./../../components/AcceleratorReview";
import Select2 from "v-select2-component";
export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Article,
    Review,
  },
  data() {
    return {
      pageLoaded: false,
      moment: moment,
      proposal: {},
      colleague: {},
      mehvars: [],
      companies: [],
      universities: [],
      tabIndex: 0,
      isLoaded: false,
      writersField: [
        { key: "index", label: "#" },
        { key: "nameEn", label: "نام و نام خانوادگی (انگلیسی)" },
        { key: "name", label: "نام و نام خانوادگی (فارسی)" },
        { key: "nationality", label: "ملیت" },
        { key: "position", label: "نقش نویسنده" },
      ],
      acc: 0,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
    };
  },
  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    getInfo() {
      this.isLoaded = false;
      (this.proposal = {
        faSubject: "ثبت سریع مقاله تستی آرینا",
        initialObligation: false,
        ISSN: ["1617-7959", "۱۲۳۴"],
        abstract: "",
        acknowledgment: "",
        adminMessage: "",
        articleAcceptanceDate: "",
        articleFinancialSupport: "",
        articlePdfFile: "",
        articlePdfFileId: "",
        articlePublicationDate: "",
        articleReleaseDate: "",
        articleRevisionDate: "",
        articleSubmissionDate: "",
        colleagues: [
          {
            id: "6278b238ca3537165c6eb89c",
            name: "تست",
            nameEn: "Robert J. Asaro",
            nationality: "تست",
            position: "تست",
          },
        ],
        consentResponsibleAuthorFile:
          "undefined/setad/private/article\\6278b238ca3537165c6eb8a0\\1652076996733TutiaTeb Change Log.docx",
        consentResponsibleAuthorFileId: "6278b1c4ca3537165c6eb814",
        doi: "10.1016/j.jbiomech.2016.11.064",
        enSubject:
          "Vital erythrocyte phenomena: what can theory, modeling, and simulation offer?",
        executorBankAccountName: "تست",
        executorBankName: "تست",
        executorIBAN: "123",
        executorTel: "1234",
        faSubject: "ثبت سریع مقاله تستی آرینا",
        fastSub: true,
        impactFactor: 2,
        initialObligation: false,
        isArchive: false,
        keywords: "",
        lastUpdated: "",
        mehvarId: "6154005e099e14274252ebca",
        otherMehvars: "",
        otherUniversity: "",
        promiseArrays: [],
        registerDate: "1401/02/19",
        rejectionIds: [],
        requestsCode: "biodc-2002154-2002254.1",
        responsibleAuthor: false,
        revision: "1",
        status: "ثبت شده",
        typePractical: false,
        typeStudy: false,
        typeSystemicDevelopmental: true,
        universityId: "61540047099e14274252ea5a",
        uploadedFiles: [
          {
            id: "6278b1c4ca3537165c6eb814",
            showName: "TutiaTeb Change Log.docx",
            url: "undefined/setad/private/article\\fastSub\\1652076996733TutiaTeb Change Log.docx",
          },
        ],

        zoneAgriculture: true,
        zoneBioComputing: false,
        zoneEnvironment: true,
        zoneIndustrial: false,
        zoneMedicine: false,
        zoneOther: false,
        promiseArrays: [true, true, true, true],
      }),
        (this.isLoaded = true);
      this.pageLoaded = true;

      // let acc = 0;
      //  //  universities
      //  this.$http
      //    .post(
      //      this.baseUrl + "/setad/options/universities",
      //      {},
      //      {
      //        headers: {
      //          Authorization: "Bearer: " + localStorage.getItem("userId"),
      //        },
      //      }
      //    )
      //    .then((res) => {
      //      this.universities = res.data;
      //      this.universities.push(
      //        new Object({
      //          id: this.notUniversity,
      //          text: "سایر دانشگاه ها",
      //        })
      //      );
      //      this.universities.unshift({
      //        id: 0,
      //        name: "--گزینه مورد نظر خود را انتخاب نمایید--",
      //        disabled: "true",
      //      });
      //      acc++;
      //    })
      //    .catch((err) => {
      //      console.log(err)
      //    });
      //  /////////////////////////////////////////////
      //  //  mehvars
      //  this.$http
      //    .post(
      //      this.baseUrl + "/setad/options/uniMehvars",
      //      {},
      //      {
      //        headers: {
      //          Authorization: "Bearer: " + localStorage.getItem("userId"),
      //        },
      //      }
      //    )
      //    .then((res) => {
      //      this.mehvars = res.data;
      //      acc++;
      //    })
      //    .catch((err) => {
      //      console.log(err)
      //    });
      //  /////////////////////////////////////////////
      //  // companies
      //  this.$http
      //    .post(
      //      this.baseUrl + "/setad/options/companies",
      //      {},
      //      {
      //        headers: {
      //          Authorization: "Bearer: " + localStorage.getItem("userId"),
      //        },
      //      }
      //    )
      //    .then((res) => {
      //      this.companies = res.data;
      //      this.companies.forEach((x) => {
      //        x.text = x.name;
      //      });
      //      this.companies.push(
      //        new Object({
      //          id: this.notCompany,
      //          text: "سایر شرکت ها",
      //        })
      //      );

      //      acc++;
      //    })
      //    .catch((err) => {
      //      console.log(err)
      //    });

      //    //get info
      //     this.$http
      //    .post(
      //      this.baseUrl + "",
      //      {
      //        requestId: this.$route.params.id,
      //      },
      //      {
      //        headers: {
      //          Authorization: "Bearer: " + localStorage.getItem("userId"),
      //        },
      //      }
      //    )
      //    .then((res) => {
      //      this.proposal = res.data.request;
      //      acc++;
      //      if (acc > 2) {
      //        try {
      //          document.body.classList.toggle("sidebar-minimized");
      //          document.body.classList.toggle("brand-minimized");
      //          this.toast(
      //            "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
      //          );
      //        } catch {}
      //        this.$bvModal.hide("loading");
      //        this.isLoaded = true;
      //      }
      //      setTimeout(() => {
      //        // NOTE (m-setTimeout) to set timeout for 200 ms
      //        this.pageLoaded = true;
      //      }, 200);
      //    })
      //    .catch((err) => {
      //      console.log(err)
      //    });
    },
  },
  mounted() {
    this.getInfo();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>

<style></style>
